import React, { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router';
export default function Activate() {
    var postdat = {
        "uid": " ",
        "token": " "
    }
    let navigate = useNavigate();
    const img = require("../IMAGES/logoR.png");
    useEffect(() => {
        // document.getElementsByClassName('nav-menu')[0].style.display = 'flex'
        // document.getElementsByClassName('navbar')[0].style.display = 'none'
        var str = window.location.href;
        var res = str.split("/");
        let div = document.getElementsByClassName('loadmain')[0];
        postdat.token = res[(res.length) - 1];
        postdat.uid = res[(res.length) - 2];
        div.style.display = 'flex';
        // fetch(`https://www.googleapis.com/customsearch/v1?q=convert 2 USD to INR`).then((res) => res.json())
        // .then((json) => {
        //     console.log(json.rates['INR'])
        //     // setCurr(json.rates['INR'])
        // })
        // var options = {
        //     method: 'GET',
        //     url: 'https://currency-converter10.p.rapidapi.com/currency.indilabz.in/api/v1/usd/inr/12',
        //     headers: {
        //       'x-rapidapi-host': 'currency-converter10.p.rapidapi.com',
        //       'x-rapidapi-key': '4580ed6aebmshaa1f8138d955654p11a8d7jsn0cb4d8ef933c'
        //     }
        //   };
        //   axios.request(options).then(function (response) {
        //     console.log(response.data);
        // }).catch(function (error) {
        //     console.error(error);
        // });
        // axios.get(`https://www.currency-converter.org.uk/widget/CCUK-CC2-AJAX.php?ConvertTo=EUR&ConvertFrom=GBP&amount=1`, {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         // 'Authorization': `Basic bG9kZXN0YXI6djdhOFdUZHZ3MTRmV2hRUEJMTEdiam5VYTNEWGN5RmM=`,
        //         'Accept': 'application/json'
        //     }
        // })
        //     .then(async response => {
        //         console.log(response)
        //         // setData(response.data)
        //     }).catch(err => {
        //         console.log(err)
        //     })
        // window.open('https://www.codegrepper.com', '_blank', 'toolbar=0,location=0,menubar=0');
        // var windowName = 'userConsole';
        // var popUp = window.open('https://www.codegrepper.com', windowName, 'width=1000, height=700, left=24, top=24, scrollbars, resizable');
        // if (popUp == null || typeof (popUp) == 'undefined') {
        //     alert('Please disable your pop-up blocker and click the "Open" link again.');
        // }
        // else {
        //     console.log(popUp.document.getElementsByTagName('body')[0]);
        //     // popUp.close()
        // }
        // popup.blur();
        // window.focus();
        // window.open();
        axios.post(`${process.env.REACT_APP_API_URL1}/auth/users/activation/`,postdat )
            .then(response => {
                div.style.display = 'none';
                // document.getElementsByClassName('nav-menu')[0].style.display = 'block'
                // document.getElementsByClassName('navbar')[0].style.display = 'block'
                navigate('/SignIn')
            }).catch(err => {
                div.style.display = 'none';
                if(err.response.status==500){
                    try {
                        notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        Server busy, Please try after some time
                        </div>`;
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                    } catch (e) { console.log(e) }
                }
                let notify = document.getElementsByClassName('noti')[0];
                // document.getElementsByClassName('nav-menu')[0].style.display = 'block'
                // document.getElementsByClassName('navbar')[0].style.display = 'block'
                navigate('/')
            })
    }, [])
    // function setUserAgent(window, userAgent) {
    //     // Works on Firefox, Chrome, Opera and IE9+
    //     if (navigator.__defineGetter__) {
    //         navigator.__defineGetter__('userAgent', function () {
    //             return userAgent;
    //         });
    //     } else if (Object.defineProperty) {
    //         Object.defineProperty(navigator, 'userAgent', {
    //             get: function () {
    //                 return userAgent;
    //             }
    //         });
    //     }
    //     // Works on Safari
    //     if (window.navigator.userAgent !== userAgent) {
    //         var userAgentProp = {
    //             get: function () {
    //                 return userAgent;
    //             }
    //         };
    //         try {
    //             Object.defineProperty(window.navigator, 'userAgent', userAgentProp);
    //         } catch (e) {
    //             window.navigator = Object.create(navigator, {
    //                 userAgent: userAgentProp
    //             });
    //         }
    //     }
    // }
    return (
        <div className='signupdiv act'>
            <img className='logo' src={img} alt="" />
        </div>
    )
}
